module.exports = __webpack_public_path__ + "media/images/questionnaire_examples/concept_testing_service-d97d584b6d29da043c485feeae1dccfb.png";